import React, { Component } from 'react'
import { Flex, Box } from 'rebass'
import NavLink from './NavLink'
import NavDrawer from './NavDrawer'
import styled from 'styled-components'
import { colors, fonts } from '../../theme'

const OnlySmallScreenBox = styled(Box)`
  display: none;
  @media (max-width: 48em) {
    display: block;
  }
  
`
const OnlyLargeScreenBox = styled(Box)`
  @media (max-width: 48em) {
    display: none;
  }
`
const CustomBox = styled(Box)`
  border-radius: 12px;
  @media (max-width: 48em) {
    border-radius: 0;
  }
`
const SpanBox = styled('span')`
  color: ${colors.primary};
  font-weight: 600;
  font-size: 30px;
  font-family: ${fonts.secondary};
  @media (max-width: 1110px) {
    display: none;
  }
  @media (max-width: 766px) {
    display: inline;
    font-size: 25px;
  }
`

class Navbar extends Component {
  render() {
    return (
      <CustomBox
        mt={this.props.fullDesign ? '-40px' : '0'}
        bg="white"
        mx={this.props.fullDesign ? [0, 0, 4, 5] : '0'}
        py={2}
        style={{
          borderRadius: this.props.fullDesign ? '12px' : 0,
          boxShadow: this.props.fullDesign
            ? 'none'
            : '0 0.2rem 0.5rem rgba(0,0,0,.2)',
        }}
      >
        <Flex
          flexDirection="row"
          justifyContent="space-between"
          px={[3]}
          alignItems="center"
          ml={2}
          my={1}
        >
          <Flex alignItems="center" flexDirection="row">
            <img src="/img/logo.jpg" style={{ height: '46px' }} />
            <SpanBox> JAIN S N & CO.</SpanBox>
          </Flex>
          <Flex
            alignItems="center"
            justifyContent="flex-end"
            mt="6"
            mr={2}
            display="inline"
          >
            <OnlyLargeScreenBox>
              <NavLink to="#" children="Home" />
              <NavLink to="#about" children="About" />
              <NavLink to="#team" children="Team" />
              <NavLink to="#values" children="Values" />
              <NavLink to="#services" children="Services" />
              <NavLink to="#articles" children="Articles" />
              <NavLink to="#contact" children="Contact" />
            </OnlyLargeScreenBox>
            <OnlySmallScreenBox>
              <NavDrawer />
            </OnlySmallScreenBox>
          </Flex>
        </Flex>
      </CustomBox>
    )
  }
}

export default Navbar



// WEBPACK FOOTER //
// ./src/elements/Navbar/Navbar.js